<template>

  <div class="card-base card-shadow--medium widget small-widget queue-widget">
    <div class="widget-value ph-10">
      <div class="flex mb-10 mt-10 align-center">
        <span class="mr-5 flex justify-center align-center">
          <v-svg width="18" height="18" class="voxo-blue" sprite="call-inbound"/>
        </span>
        <el-input
          class="widget-name-input ml-10"
          v-model="widgetName"
        />
        <el-button
          @click="removeWidget"
          class="table-action-button ml-10"
        >
          <i class="el-icon-delete voxo-dark-red" />
        </el-button>
      </div>

      <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
        {{ widgetValue }}
      </h1>
    </div>

    <div class="stat-widget-table ph-10" v-show="isMultiQueue">
      <vxe-table
        round
        height="100%"
        border="inner"
        ref="xGrid"
        class="user-stats-table"
        empty-text="No Data"
        sync-resize
        auto-resize
        :checkbox-config="{checkAll: determineCheckAll()}"
        @checkbox-change="checkboxesChanged"
        @checkbox-all="checkboxesChanged"
        :show-overflow="true"
        :scroll-y="{enabled: true, gt: 10, oSize: 0}"
        :data="queueStoreData"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="30"
        />
        <vxe-table-column
          field="queueId"
          title="Queue"
          min-width="200"
          sortable
          :formatter="getQueueName"
        />
        <vxe-table-column
          field="totalInbound"
          title="Count"
          min-width="80"
          sortable
          sort-type="number"
        />
      </vxe-table>
    </div>

  </div>

</template>

<script>

import {mapGetters} from "vuex";
import {debounce} from 'lodash';

export default {
  name: 'InboundCallsQueue',
  props: {
    widgetIndex: {required: true},
    title: {required: true},
    filterQueueIds: {required: true},
    queueNameKey: {required: true},
  },
  data() {
    return {
      widgetValue: 0,
      widgetName: this.title,
      filtersActive: false,
      filterQueues: this.filterQueueIds,
      viewStyle: 'default'
    }
  },
  computed: {

    ...mapGetters('queueDashQueues', {queueStoreData: 'list'}),

    totalInbound() {
      return this.$store.state.queueManagerAggregates.totalInbound;
    },

    isMultiQueue() {
      return this.queueStoreData.length > 1;
    }
  },
  watch: {
    totalInbound: debounce(function () {
      this.widgetValue = this.filtersActive ? this.getFilteredValue() : this.totalInbound;
    }, 150),
    widgetName: debounce(function() {
      if(this.widgetName === this.title) return;
      this.$emit('nameUpdate', {name: this.widgetName, index: this.widgetIndex});
    }, 750),
    filterQueues: debounce(function () {
      this.$emit('filterQueuesUpdate', {filterQueueIds: this.filterQueues, index: this.widgetIndex})
    }, 750)
  },
  methods: {

    checkboxesChanged({records}) {

      console.log('checkbox change');

      this.filterQueues = records.map(item => item.queueId);

      if(this.filterQueues.length === this.queueStoreData.length){
        this.widgetValue = this.totalInbound;
        this.filtersActive = false;
        return;
      }

      this.widgetValue = this.getFilteredValue();
      this.filtersActive = true;
    },

    getQueueName(data) {
      const { cellValue } = data;
      return this.queueNameKey[cellValue] ? this.queueNameKey[cellValue] : 'Unknown';
    },

    removeWidget(){
      this.$emit('removeWidget', this.widgetIndex);
    },

    getFilteredValue() {

      if(!this.filterQueues.length) return 0;

      let value = 0;
      for (let item of this.queueStoreData) {
        if (this.filterQueues.includes(item.queueId)) {
          value += item.totalInbound;
        }
      }

      return value;
    },

    determineCheckAll() {

      const hasFilter = this.filterQueues.length !== this.queueStoreData.length;

      if(!hasFilter){
        this.getInitialValue();
        return true;
      }

      if(hasFilter){
        this.filtersActive = true;
        this.updateCheckboxes();
        return false;
      }

    },

    async updateCheckboxes() {
      setTimeout(() => {
        const checkedRows = this.queueStoreData.filter(item => this.filterQueues.includes(item.queueId));
        const grid = this.$refs.xGrid;
        if(grid){
          grid.setCheckboxRow(checkedRows,checkedRows);
          this.widgetValue = this.getFilteredValue();
        }
      }, 500)
    },

    getInitialValue() {
      setTimeout( () => {
        this.widgetValue = this.getFilteredValue();
      }, 500)
    }
  }
}

</script>
